import { render, staticRenderFns } from "./RePlace.vue?vue&type=template&id=04efc310&scoped=true"
import script from "./RePlace.vue?vue&type=script&lang=js"
export * from "./RePlace.vue?vue&type=script&lang=js"
import style0 from "./RePlace.vue?vue&type=style&index=0&id=04efc310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efc310",
  null
  
)

export default component.exports